const commentStrings = {
    comment_deleted: {
        "en-us": "COMMENT DELETED"
    }
};


export default commentStrings;
